// YVES-320: Restore cookie consent after login when Shopify resets visitor privacy state.
(function () {
  const STORAGE_KEY = 'wd_visitor_consent';

  function readStoredConsent() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  function saveStoredConsent(detail) {
    if (!detail) return;

    const consent = {
      analytics: detail.analyticsAllowed,
      marketing: detail.marketingAllowed,
      preferences: detail.preferencesAllowed,
      sale_of_data: detail.saleOfDataAllowed,
    };

    const hasDecision = Object.values(consent).some((value) => typeof value === 'boolean');
    if (!hasDecision) return;

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
    } catch {}
  }

  function hideShopifyBanner() {
    const banner = document.getElementById('shopify-pc__banner');
    if (banner) banner.style.display = 'none';
  }

  function restoreStoredConsent() {
    const api = window.Shopify?.customerPrivacy;
    const stored = readStoredConsent();

    if (!api || !stored || !api.shouldShowBanner?.()) return;

    const payload = {};
    if (typeof stored.analytics === 'boolean') payload.analytics = stored.analytics;
    if (typeof stored.marketing === 'boolean') payload.marketing = stored.marketing;
    if (typeof stored.preferences === 'boolean') payload.preferences = stored.preferences;
    if (typeof stored.sale_of_data === 'boolean') payload.sale_of_data = stored.sale_of_data;

    if (Object.keys(payload).length === 0) return;

    api.setTrackingConsent(payload, hideShopifyBanner);
  }

  document.addEventListener('visitorConsentCollected', (event) => {
    saveStoredConsent(event.detail);
  });

  function init() {
    if (!window.Shopify?.loadFeatures) {
      window.setTimeout(init, 50);
      return;
    }

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (error) => {
        if (!error) restoreStoredConsent();
      }
    );
  }

  init();
})();
